var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.6500122,11.049947 H 9.349988 v 1.70003 H 7.6500122 Z m 0,-6.7999648 H 9.349988 V 9.35002 H 7.6500122 Z M 8.491514,0 C 3.7995061,0 0,3.8079867 0,8.499954 0,13.191942 3.7995061,17 8.491514,17 13.192028,17 17,13.191942 17,8.499954 17,3.8079867 13.192028,0 8.491514,0 Z m 0.0085,15.29997 c -3.7570024,0 -6.8000141,-3.042958 -6.8000141,-6.800016 0,-3.7569663 3.0430117,-6.7999652 6.8000141,-6.7999652 3.756982,0 6.800055,3.0429989 6.800055,6.7999652 0,3.757058 -3.043073,6.800016 -6.800055,6.800016 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert_error.e5f799e07c6100321b99236a4170fa72.svg";
export { ForwardRef as ReactComponent };